import { type AdmissionOffer } from 'AdmissionOffer';
import { getProduct, type StripeProductId } from 'Stripe';

// The locale namespace every registration screen reads its keys from.
export const LOCALE_PREFIX = 'settings.tuition_and_registration';

// Program types double as Stripe product ids.
export function stripeProductIdFor(admissionOffer: AdmissionOffer): string {
    return getProduct(admissionOffer.programType as unknown as StripeProductId).id;
}
